import { state } from '@angular/animations';
import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-issue-seller-labels-of-hand-delivery',

  templateUrl: './issue-seller-labels-of-hand-delivery.component.html',
  styleUrl: './issue-seller-labels-of-hand-delivery.component.scss'
})


export class IssueSellerLabelsOfHandDeliveryComponent implements OnInit {
  labelsData;
  publish_date;
  state;
  sub_mode;
  vitarandate;
  ankdate;
  tempdata;
  total_sub_count;
  data1 = [];
  FilteredlabelsData = [];
  disRepData = [];
  dataone: any;
  datatwo: any;
  combinedList: any;
  dispatchdate: any;
  dist_name: any;
  dis_mode: any;
  dis_sub_mode: any;
  filteredList: any;
  isuuedate: any;

  dis_date: any;
  updateStatus: any = false
  issueName: any;
  category: any;

  constructor(
    private dialogref: MatDialogRef<IssueSellerLabelsOfHandDeliveryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

district:any
taluka :any
pincode :any
  ngOnInit(): void {
    debugger;
    // this.dist_name = this.data.dist_name,
      this.dis_mode = this.data.dis_mode,
      this.dis_sub_mode = this.data.dis_sub_mode,
      this.isuuedate = this.data.isuuedate,
      this.dispatchdate = this.data.dispatchdate,
      this.updateStatus = this.data.updateStatus,
     this.state = this.data.state;
    this.district = this.data.district;
    this.taluka = this.data.taluka,
    this.pincode = this.data.pincode,
    this.issueName = this.data.issueName,
    this.category = this.data.category


      this.dataone = this.data.data1,
      this.datatwo = this.data.data2,
      this.dispatchdate = this.data.dispatchdate
    console.log(this.dataone, this.datatwo, "intial data")
    // this.service
    //   .getDistributionRepresentativeSBhetHastewise()
    //   .subscribe((res) => {
    //     this.disRepData = res;
    //     // console.log(this.disRepData);


    //   });
    // *************************COMMENTED CODE IS PREVIOUS CODE*******************************************************
    // this.labelsData = this.data['data'].filter((a) => {
    //   return a['dis_mode'] ===this.data['dis_mode'];
    // });
    this.dis_mode = this.data['dis_mode'];
    this.sub_mode = this.data['dis_sub_mode'];
    this.dis_date = this.data['dispatchdate']

    this.combinedList = this.dataone;

    console.log(this.combinedList, "Intial list")
    
    if (this.updateStatus) {


      this.combinedList.forEach(element => {
        element.sub_count = 0;
  
      });
  
      for (let j = 0; j < this.datatwo.length; j++) {
        let matchFound = false;
  
        for (let i = 0; i < this.combinedList.length; i++) {
  
          if (this.combinedList[i].issueSellerName === this.datatwo[j].dsi_rep) {
  
            this.combinedList[i].sub_count = this.datatwo[j].count;
  
            this.combinedList[i].dist = this.datatwo[j].district;
            this.combinedList[i].taluka = this.datatwo[j].taluka;
            this.combinedList[i].state = this.datatwo[j].state;
            this.combinedList[i].dis_mode = this.datatwo[j].dis_mode;
            this.combinedList[i].dis_sub_mode = this.datatwo[j].dis_sub_mode;
            this.combinedList[i].dis_date = this.datatwo[j].dispatchdate;
            this.combinedList[i].prati = parseInt(this.combinedList[i].sub_count) + parseInt(this.combinedList[i].s_bhet);
  
            matchFound = true; // Set match found flag to true
            break; // Exit the loop as we've found a match
          }
        }
  
        // If no match was found, add a new object to `combinedList`
        if (!matchFound) {
          const newEntry = {
            issueSellerName: this.datatwo[j].dsi_rep,
            sub_count: this.datatwo[j].count,
            // state: this.datatwo[j].state,
            dis_dist: this.datatwo[j].district,
            dis_tal: this.datatwo[j].taluka,
            dis_mode: this.datatwo[j].dis_mode,
            dis_sub_mode: this.datatwo[j].dis_sub_mode,
            dis_date: this.datatwo[j].dispatchdate,
            s_bhet: 0,
            mob_no: this.datatwo[j].mob_no,
            full_add: this.datatwo[j].full_add,
            prati: this.datatwo[j].count
          };
  
          this.combinedList.push(newEntry); // Add new object to `combinedList`
        }
      }
  
      console.log(this.combinedList, "finale combinedList list");
  
      // this.filteredList = this.combinedList.filter(item =>
      //   item.dis_mode === this.dis_mode &&
      //   item.dis_sub_mode === this.dis_sub_mode &&
      //   item.issueSellerName === this.dist_name
      // );
      debugger;
  
  
      this.filteredList = this.combinedList.filter((a) => {
        debugger;
        let dismodeCondition = true;
        if (this.dis_mode != '' && this.dis_mode != undefined) {
          // dismodeCondition = this.dis_mode.includes(a['dis_mode']);
          dismodeCondition = a['dis_mode'] !== "" && this.dis_mode === a['dis_mode'];
  
        }
  
        let dis_subModeCondition = true;
        if (this.dis_sub_mode != '' && this.dis_sub_mode != undefined) {
          // dis_subModeCondition = this.dis_sub_mode.includes(a['dis_sub_mode']);
          dis_subModeCondition = a['dis_sub_mode'] !== "" && this.dis_sub_mode === a['dis_sub_mode'];
  
        }
  
        let dist_nameCondition = true;
        if (this.dist_name != '' && this.dist_name != undefined) {
          // dist_nameCondition = this.dist_name.includes(a['issueSellerName']);
          dist_nameCondition = a['dis_dist'] !== "" && this.dist_name === a['dis_dist'];
        }
  
        return (
          dismodeCondition &&
          dis_subModeCondition &&
          dist_nameCondition
          // Add more conditions here
        );
      })
  
      console.log(this.filteredList, "filterlist")
    this.getDistrictwiseStatementList();
    } else {
      this.getparcelLabel();
    }



  }


  saveSubscriptionBarcodesDataEntry() {
    console.log(this.filteredList);
    const filteredData = this.filteredList.map((item) => ({
      issue_date: this.isuuedate,
      country: "भारत",
      // state: item.state,
      number_of_subscribers: item.sub,
      total: this.total_sub_count,
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchdate),
      delivery_mode: item.delivery_mode,
      dispatch_date: this.convertDateFormat(this.dispatchdate),
      dis_mode: this.dis_mode,
      dis_sub_mode: this.dis_sub_mode,
      // no_of_books_in_bundle: item.parcel.split("=")[1],
      //bundle_count: item.parcel.split("=")[0],
      district: item.district,
      distribution_mode: item.dis_mode,
      sub_distribution_mode: item.dis_sub_mode,
      parcel_label_username_address: item.full_add,
      parcel_label_username_mobile_no: item.mob_no,
      parcel_label_pieces: item.prati,
      parcel_label_username: item.issueSellerName,
      state: this.state



    }));
    console.log(filteredData);
    this.service.saveIssueSellerParcelLabelDataEntry(filteredData).subscribe((data) => {
      alert('parcel Label Save Successfully!');
    });
  }

  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  getparcelLabel() {
    const request = {
      issue_date: this.isuuedate,
      country: "भारत",
      // districts:this.district,
      // state: this.state
    }
    this.service.getIssueSellerparcelLabel(request).subscribe((data: any) => {
      this.filteredList = data
    });
  }



sumOfTotal:any=0
  getDistrictwiseStatementList() {
    this.combinedList = []
    const request = {
      "issue_date": this.isuuedate,
      "stateName": this.state,
      "issueName": this.issueName,
      "category": this.category,
      // "districtName": this.dist_name,
      // "talukaName": this.dist_name,
      "pincode": this.pincode,
      "distributionMode": this.dis_mode,
      "subDistributionMode": this.dis_sub_mode
    }
    this.service.getIssueSellerAllDistributerCopiesList(request).subscribe((data: any) => {
      this.combinedList = data.data;
      this.filteredList= data.data;
    });
  }
 
  
}